export default "__VITE_ASSET__f6181377__"